<template>
  <component :is="$route.meta.layout || 'DefaultLayout'">
    <router-view :key="$route.fullPath" />
  </component>
</template>

<script>
import BlitzLayout from '../layouts/BlitzLayout.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'

export default {
  components: {
    BlitzLayout,
    DefaultLayout
  }
}
</script>
